<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc-fm"><a href="#/xhtml/05_Intro">Introduction</a></h2>
<h2 class="toc-fm"><a href="#/xhtml/06_Series">Series Editor’s Introduction</a></h2>
<h2 class="toc-chap"><a href="#/xhtml/07_Chapter01#ch1"><span class="chap"><span class="bold">Chapter 1</span></span> The Strategic Context</a></h2>
<h2 class="toc-chap"><a href="#/xhtml/08_Chapter02#ch2"><span class="chap"><span class="bold">Chapter 2</span></span> The Last Stand on the Yser</a></h2>
<h2 class="toc-chap"><span href="#/xhtml/09_Chapter03#ch3" title="Link target outside of Sample"><span class="chap"><span class="bold">Chapter 3</span></span> Inundation</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/10_Chapter04#ch4" title="Link target outside of Sample"><span class="chap"><span class="bold">Chapter 4</span></span> The Northernmost Part of the Western Front</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/11_Chapter05#ch5" title="Link target outside of Sample"><span class="chap"><span class="bold">Chapter 5</span></span> Politics and the Shaping of Memory</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/12_Chapter06#ch6" title="Link target outside of Sample"><span class="chap"><span class="bold">Chapter 6</span></span> The Tours</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/13_TourA" title="Link target outside of Sample"><span class="chap"><span class="bold">Tour A</span></span> Nieuwpoort, Lombardsijd and Ramskapelle</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/14_TourB" title="Link target outside of Sample"><span class="chap"><span class="bold">Tour B</span></span> Diksmuide</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/15_TourC" title="Link target outside of Sample"><span class="chap"><span class="bold">Tour C</span></span> The Belgian Rear of the Yser Front</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/16_TourD" title="Link target outside of Sample"><span class="chap"><span class="bold">Tour D</span></span> Drie-Grachten, Merkem and Steenstraat</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/17_TourE" title="Link target outside of Sample"><span class="chap"><span class="bold">Tour E</span></span> The Towns of the Belgian Rear</span></h2>
<h2 class="toc-fm_1"><span href="#/xhtml/18_Othernotable" title="Link target outside of Sample">Other Notable Sites in the Area</span></h2>
<h2 class="toc-fm"><span href="#/xhtml/19_app" title="Link target outside of Sample">Appendix: The Belgian Army</span></h2>
<h2 class="toc-fm"><span href="#/xhtml/20_Bibliography" title="Link target outside of Sample">Selective Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?e5096434